/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {

    // Remove empty P tags created by WP inside of Accordion and Orbit
    $('.accordion p:empty, .orbit p:empty').remove();

	 // Makes sure last grid item floats left
	$('.archive-grid .columns').last().addClass( 'end' );

	// Adds responsive-embed (used to be flex-video) and other parameters to YouTube and Vimeo Embeds that don't already have it
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if (!$(this).closest('.responsive-embed').length) {
      var classes = 'responsive-embed widescreen ';
      if ($(this).attr('src').match(/vimeo.com/ig)) {
        classes = classes + 'vimeo';
      }
      if ($(this).attr('src').match(/youtube.com/ig)) {
        classes = classes + 'youtube';
      }
      console.log('no wrapper');
      $(this).wrap("<div class='" + classes + "'/>");
    }
  });

});
